import axios from '../../axios';
import * as types from './mutation-types'
const state = () => ({
	albums: ''
})
const actions = {
	fetchAlbums({ commit }) {
		return axios.get('/albums').then(response => commit(types.STORE_ALBUMS, response.data))
	}
}
const mutations = {
	[types.STORE_ALBUMS](state, albums) {
		state.albums = albums;
	}
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
